import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Input } from 'reactstrap';
import UpdateStoreUserRoleMappingService from '../../../../../../../../Service/OPSServices/AccountDetailsService/UpdateStoreUserRoleMappingService';
import notify from '../../../../../../../../Notifications/ToastifyActions';
import FetchStoreUserRoleMappingDataService from '../../../../../../../../Service/OPSServices/AccountDetailsService/FetchStoreUserRoleMappingDataService';
import ProductsPagination from '../../../../../../../Components/Pagination/ProductsPagination';
import { connect } from 'react-redux';


const SWTeamRolesCard = (props) => {

  const [mappingSearchText, setMappingSearchText] = useState('');
  const [mappingCurrentPage, setMappingCurrentPage] = useState(0);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [loadingRowId, setLoadingRowId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown-wrapper")) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const filteredMapping = props.mappingTable && props.mappingTable.filter((row) => {
    const store = (row.store || '').toLowerCase();
    const role = (row.role || '').toLowerCase();
    const user = (row.user || '').toLowerCase();

    return (
      store.includes(mappingSearchText.toLowerCase()) ||
      role.includes(mappingSearchText.toLowerCase()) ||
      user.includes(mappingSearchText.toLowerCase())
    );
  });

  const mappingPageSize = 5;
  const mappingStartIndex = mappingCurrentPage * mappingPageSize;
  const mappingEndIndex = mappingStartIndex + mappingPageSize;
  const totalFilteredMapping = filteredMapping ? filteredMapping.length : 0;
  const mappingTotalPages = Math.ceil(totalFilteredMapping / mappingPageSize);

  const handleMappingPageChange = (page) => {
    if (page >= 0 && page < mappingTotalPages) {
      setMappingCurrentPage(page);
    }
  };

  const paginatedMapping = filteredMapping ? filteredMapping.slice(mappingStartIndex, mappingEndIndex) : [];

  const handleCheckboxChange = (e, userId, row) => {
    let updatedUserIds = row.userIds ? [...row.userIds] : [];

    if (e.target.checked) {
      updatedUserIds.push(userId);
    } else {
      updatedUserIds = updatedUserIds.filter((id) => id !== userId);
    }

    setLoadingRowId(row.id);

    let data = {
      storeId: row.storeId,
      roleId: row.roleId,
      userIds: updatedUserIds
    };

    UpdateStoreUserRoleMappingService(props.token, data).then((res) => {
      if (res.success) {
        const updatedTable = props.mappingTable.map((item) => {
          if (item.id === row.id) {
            return {
              ...item,
              userIds: updatedUserIds,
              user: props.memberDropdown
                .filter((m) => updatedUserIds.includes(m.id))
                .map((m) => m.name)
                .join(", ")
            };
          }
          return item;
        });

        props.setMappingTable(updatedTable);
        notify.NotifySuccess(res.message);
      } else {
        notify.NotifyWarning(res.message);
      }
      setLoadingRowId(null);
    });
  };

  return (
    <Col md={props.isModal ? 12 : 6} className={props.isModal ? "p-0" : ""}>
      <Card
        className='p-3 card-of-problemarea'
      >
        <Row>
          {/* <Col md={4}>
            <h5 className="mb-3"><b>SW Team Roles</b></h5>
          </Col> */}
          <Col md={12}>
            <div className="d-flex justify-content-end align-items-end mb-2">
              <Input
                type="text"
                className="w-50"
                placeholder="Search..."
                value={mappingSearchText}
                onChange={(e) => {
                  setMappingSearchText(e.target.value);
                  setMappingCurrentPage(0);
                }}
              />
              <div className="ml-3 mt-2">
                <ProductsPagination
                  currentPage={mappingCurrentPage}
                  totalRecords={totalFilteredMapping}
                  pageSize={mappingPageSize}
                  onPageChange={handleMappingPageChange}
                />
              </div>
            </div>
          </Col>

          <table className="table ml-2 mr-1" style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '18%' }}>Store</th>
                <th style={{ width: '22%' }}>Role</th>
                <th style={{ width: '25%' }}>Members</th>
                <th style={{ width: '35%' }}>Member List</th>
              </tr>
            </thead>
            <tbody>
              {paginatedMapping && paginatedMapping.length > 0 ? (
                paginatedMapping.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <p title={row.store} className="comment-paragraph-storeuser-rolemapping mb-0">
                        {row.store}
                      </p>
                    </td>

                    <td>{row.role}</td>

                    <td style={{ position: "relative" }}>
                      <div
                        className="dropdown-wrapper"
                        // onMouseDown={(e) => e.stopPropagation()}
                      >
                        <div
                          className="custom-select-box"
                          style={{ color: '#767373', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenDropdownId(openDropdownId === row.id ? null : row.id);
                          }}
                        >
                          --Select Members--
                        </div>

                        {openDropdownId === row.id && (
                          <div className="custom-dropdown">
                            {props.memberDropdown.map((m) => (
                              <label key={m.id} className="dropdown-item d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  checked={row.userIds && row.userIds.includes(m.id)}
                                  disabled={loadingRowId === row.id}
                                  onChange={(e) => handleCheckboxChange(e, m.id, row)}
                                />
                                <span className="ml-2">{m.name}</span>
                              </label>
                            ))}
                          </div>
                        )}
                      </div>
                    </td>

                    <td>
                      <p title={row.user || ""} className='comment-paragraph-storeuser-rolemapping mb-0'>
                        {row.user || ""}
                      </p>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Row>
      </Card>
    </Col>
  );
};

const mapStateToProps = state => {
  return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
      globalPermissions: state.loggedUser.globalPermissions,
      adProfiles: state.accountOverview.landing.adProfiles,
  }
}

export default connect(mapStateToProps)(SWTeamRolesCard);